import { actionType as orderActionType } from './order';
import { actionType as workerActionType } from './worker';
// TODO 임시 데이터
// import { dummyOrderList, dummyWorkerList } from '/tmp/mapControlDummyData.js';
export const actionType = {
    resetStatusCount: 'resetStatusCount',
    setIsOpenConfigDialog: 'setIsOpenConfigDialog',
    setSelectedItemKey: 'setSelectedItemKey',
    setIsHQ: 'setIsHQ',
};
// 공통 도메인 액션 모음
const action = {
    [actionType.setIsHQ]({ commit }, isHQ) {
        commit('SET_IS_HQ', isHQ);
    },
    [actionType.setIsOpenConfigDialog]({ commit }, isOpen) {
        commit('SET_IS_OPEN_CONFIG_DIALOG', isOpen);
    },
    /**
     * 주문목록/라이더목록 카운트 초기화
     */
    [actionType.resetStatusCount]({ dispatch }) {
        dispatch(orderActionType.setStatusTotalCount);
        dispatch(workerActionType.setWorkerTotalCount);
    },
    /**
     * 선택한 스낵바 키값 설정
     */
    [actionType.setSelectedItemKey]({ commit }, key = -1) {
        commit('SET_SELECTED_ITEM_KEY', key);
    },
};
export default action;
